import lazyWithRetry from 'tools/lazyWithRetry';

const NotificationListPage = lazyWithRetry(() => import(
	/* webpackChunkName: "NotificationListPage" */
	'pages/notification/Notification/NotificationListPage'));

const NotificationReminderListPage = lazyWithRetry(() => import(
	/* webpackChunkName: "NotificationListPage" */
	'pages/notification/Notification/NotificationReminderListPage'));

export default [
	{ component: NotificationListPage, exact: true, path: '/stonecode_notification_notifications' },
	{ component: NotificationReminderListPage, exact: true, path: '/sub_partitions/:subPartitionId/notification_reminders' },
];
